<template>
  <nav :class="['navbar', { scrolled: scrolled }]">
    <div class="nav-content">
      <router-link to="/" class="logo">
        <div class="logo-icon">
          <img :src="logoSrc" alt="Logo" />
        </div>
        <span class="logo-text">Feedax</span>
      </router-link>

      <div class="nav-right">
        <!-- <router-link to="/apikey" class="btn btn-primary"> 获取 APIkey </router-link> -->
        <ThemeToggle class="theme-toggle-desktop" />
        <router-link v-if="userStore.profile" to="/profile" class="nav-console-link">
          控制台
        </router-link>
        <div v-if="userStore.profile" ref="dropdownRef" class="user-dropdown">
          <div class="login-status" @click="toggleDropdown">
            <div class="avatar">
              {{ avatarLetter }}
            </div>
            <span class="username">{{ userStore.userName }}</span>
            <svg
              class="dropdown-arrow"
              :class="{ open: dropdownOpen }"
              width="12"
              height="12"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
          <div v-show="dropdownOpen" class="dropdown-menu">
            <!-- <router-link to="/profile" class="dropdown-item" @click="closeDropdown">
              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              个人中心
            </router-link>
            <div class="dropdown-divider"></div> -->
            <form method="post" action="/api/logout" class="logout-form">
              <button class="dropdown-item logout" type="submit">
                <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
                退出登录
              </button>
            </form>
          </div>
        </div>
        <a v-else class="login-status login-prompt" :href="loginUrl"> 获取 APIkey </a>
        <button
          class="mobile-menu-btn"
          :class="{ active: mobileMenuOpen }"
          @click="toggleMobileMenu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </div>
  </nav>
</template>

<script setup>
  import { ref, computed, inject, onMounted, onUnmounted } from 'vue'
  import { useScroll } from '../../composables/useScroll'
  import { useUserStore } from '../../store/modules/user'
  import ThemeToggle from './ThemeToggle.vue'
  import logoDark from '@/assets/logo.png'
  import logoLight from '@/assets/logo1.png'

  const { scrolled } = useScroll()
  const userStore = useUserStore()
  const theme = inject('theme')
  const mobileMenuOpen = inject('mobileMenuOpen')
  const toggleMobileMenu = inject('toggleMobileMenu')
  const loginUrl = inject('loginUrl')

  const dropdownOpen = ref(false)
  const dropdownRef = ref(null)

  const logoSrc = computed(() => {
    return theme.value === 'dark' ? logoDark : logoLight
  })

  const avatarLetter = computed(() => {
    return userStore.nickname?.charAt(0)?.toUpperCase() || 'U'
  })

  const toggleDropdown = () => {
    dropdownOpen.value = !dropdownOpen.value
  }

  const closeDropdown = () => {
    dropdownOpen.value = false
  }

  const handleClickOutside = (e) => {
    if (dropdownRef.value && !dropdownRef.value.contains(e.target)) {
      closeDropdown()
    }
  }

  onMounted(() => {
    document.addEventListener('click', handleClickOutside)
  })

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
  })
</script>

<style scoped>
  .navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: var(--nav-bg);
    backdrop-filter: blur(30px) saturate(180%);
    -webkit-backdrop-filter: blur(30px) saturate(180%);
    border-bottom: 1px solid var(--border-color);
    z-index: 1000;
    transition: all 0.3s ease;
  }

  .navbar.scrolled {
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);
  }

  [data-theme='dark'] .navbar.scrolled {
    background: rgba(30, 41, 59, 0.95);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
  }

  .nav-content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 16px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
  }

  .logo:hover {
    opacity: 0.8;
  }

  .logo-icon {
    width: 36px;
    height: 36px;
    /* border-radius: 50%; */
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .nav-right {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-direction: row;
  }

  .nav-console-link {
    color: var(--text-secondary);
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.3s ease;
    white-space: nowrap;
  }

  .nav-console-link:hover {
    background: rgba(99, 102, 241, 0.1);
    color: var(--primary);
  }

  .login-status {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    background: var(--bg-secondary);
    backdrop-filter: blur(20px);
    border-radius: 12px;
    border: 1px solid var(--border-color);
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .login-status:hover {
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(99, 102, 241, 0.3);
  }

  [data-theme='dark'] .login-status:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f46e5, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 700;
    font-size: 14px;
  }

  .username {
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
  }

  .login-prompt {
    color: var(--primary);
    font-weight: 600;
    font-size: 14px;
  }

  [data-theme='dark'] .username {
    color: var(--text-primary);
  }

  .dropdown-arrow {
    transition: transform 0.2s ease;
    color: var(--text-secondary);
  }

  .dropdown-arrow.open {
    transform: rotate(180deg);
  }

  .user-dropdown {
    position: relative;
  }

  .dropdown-menu {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    min-width: 160px;
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(20px);
    padding: 8px 0;
    z-index: 100;
    animation: dropdownFadeIn 0.2s ease;
  }

  @keyframes dropdownFadeIn {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  [data-theme='dark'] .dropdown-menu {
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  }

  .logout-form {
    margin: 0;
    padding: 0;
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    width: 100%;
    text-decoration: none;
    color: var(--text-primary);
    font-size: 14px;
    font-weight: 500;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .dropdown-item:hover {
    background: rgba(99, 102, 241, 0.1);
    color: var(--primary);
  }

  .dropdown-item.logout {
    color: #ef4444;
  }

  .dropdown-item.logout:hover {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
  }

  .dropdown-divider {
    height: 1px;
    background: var(--border-color);
    margin: 4px 0;
  }

  .mobile-menu-btn {
    display: none;
    flex-direction: column;
    gap: 5px;
    padding: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 1001;
  }

  .mobile-menu-btn span {
    width: 24px;
    height: 2px;
    background: var(--text-secondary);
    border-radius: 2px;
    transition: all 0.3s ease;
  }

  .mobile-menu-btn.active span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }

  .mobile-menu-btn.active span:nth-child(2) {
    opacity: 0;
  }

  .mobile-menu-btn.active span:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
  }

  @media (max-width: 768px) {
    .nav-content {
      padding: 12px 20px;
    }

    .nav-right .btn-primary,
    .nav-right .nav-console-link,
    .nav-right .user-dropdown,
    .nav-right .login-status.login-prompt,
    .nav-right .theme-toggle-desktop {
      display: none;
    }

    .nav-right {
      justify-content: flex-end;
    }

    .mobile-menu-btn {
      display: flex;
    }
  }
</style>
